/** Shared constants used across multiple components */

export const entityTypeLabels: Record<string, string> = {
  default: 'Default',
  external: 'External System',
  user: 'User',
  process: 'Process',
  storage: 'Storage System',
};

export const entityTypeColors: Record<string, string> = {
  default: 'bg-gray-100 text-gray-800 ring-gray-500/10 dark:bg-gray-900/30 dark:text-gray-400 dark:ring-gray-400/30',
  external: 'bg-orange-100 text-orange-800 ring-orange-500/10 dark:bg-orange-900/30 dark:text-orange-400 dark:ring-orange-400/30',
  user: 'bg-blue-100 text-blue-800 ring-blue-500/10 dark:bg-blue-900/30 dark:text-blue-400 dark:ring-blue-400/30',
  process: 'bg-green-100 text-green-800 ring-green-500/10 dark:bg-green-900/30 dark:text-green-400 dark:ring-green-400/30',
  storage: 'bg-purple-100 text-purple-800 ring-purple-500/10 dark:bg-purple-900/30 dark:text-purple-400 dark:ring-purple-400/30',
};

export const threatStatusColors: Record<string, string> = {
  open: 'bg-red-100 text-red-800 ring-red-600/20 dark:bg-red-900/30 dark:text-red-400',
  mitigated: 'bg-blue-100 text-blue-800 ring-blue-600/20 dark:bg-blue-900/30 dark:text-blue-400',
  invalid: 'bg-gray-100 text-gray-800 ring-gray-600/20 dark:bg-gray-900/30 dark:text-gray-400',
  'in-progress': 'bg-yellow-100 text-yellow-800 ring-yellow-600/20 dark:bg-yellow-900/30 dark:text-yellow-400',
  closed: 'bg-green-100 text-green-800 ring-green-600/20 dark:bg-green-900/30 dark:text-green-400',
  removed_from_tc: 'bg-slate-100 text-slate-500 ring-slate-400/20 dark:bg-slate-900/30 dark:text-slate-500',
};

export const ciaLabels: Record<string, { label: string; color: string }> = {
  secret: { label: 'Secret', color: 'bg-purple-100 text-purple-800 ring-purple-600/20 dark:bg-purple-900/30 dark:text-purple-400' },
  confidential: { label: 'Confidential', color: 'bg-red-100 text-red-800 ring-red-600/20 dark:bg-red-900/30 dark:text-red-400' },
  internal: { label: 'Internal', color: 'bg-yellow-100 text-yellow-800 ring-yellow-600/20 dark:bg-yellow-900/30 dark:text-yellow-400' },
  public: { label: 'Public', color: 'bg-green-100 text-green-800 ring-green-600/20 dark:bg-green-900/30 dark:text-green-400' },
  standard: { label: 'Standard', color: 'bg-blue-100 text-blue-800 ring-blue-600/20 dark:bg-blue-900/30 dark:text-blue-400' },
  high: { label: 'High', color: 'bg-orange-100 text-orange-800 ring-orange-600/20 dark:bg-orange-900/30 dark:text-orange-400' },
  critical: { label: 'Critical', color: 'bg-red-100 text-red-800 ring-red-600/20 dark:bg-red-900/30 dark:text-red-400' },
  highly_critical: { label: 'Highly critical', color: 'bg-purple-100 text-purple-800 ring-purple-600/20 dark:bg-purple-900/30 dark:text-purple-400' },
  low: { label: 'Low', color: 'bg-green-100 text-green-800 ring-green-600/20 dark:bg-green-900/30 dark:text-green-400' },
};

export function getCiaLabel(level: string | null | undefined): string {
  return level ? ciaLabels[level]?.label ?? level : '—';
}
